
import { computed, reactive, ref } from "vue";
import { towerTab as tabConst, towerTabMap } from "@/const/tower/index";
import { useStore } from "@/store";
import { SysActionTypes } from "@/store/sys/action-types";
import { SysInfo } from "@/const/sys";
const store = useStore();
export default {
  name: "TowerDialog",
  emits: {
    startBattle: (payload: any) => {
      return payload;
    }
  },
  setup(_: any, { emit }: { emit: any }) {
    // dialog
    const Dialog = ref();
    const close = () => {
      Dialog.value.close();
    };
    const open = () => {
      Dialog.value.open();
    };
    // tower

    const towerTab = reactive(
      tabConst.map(({ name, value, describe }) => ({
        label: name,
        value,
        title: describe,
        disabled: false
      }))
    );
    const towterActive = ref(towerTab[0].label);
    const currentLevel = computed(() => {
      const value = store.state.userTowerLevel[towterActive.value];
      return value || 0;
    });
    const levelList = computed(() => {
      const arr = Array.from(
        new Array(currentLevel.value + 1),
        (m, index) => index + 1
      );
      return arr;
    });

    const handleStartBattle = (level: number) => {
      const monsters = towerTabMap.get(towterActive.value);
      store.dispatch(
        SysActionTypes.SYS_PUSH_INFO,
        new SysInfo(`准备进入${towterActive.value}第${level}层`, 2)
      );
      close();
      const option = {
        type: 1,
        label: towterActive.value,
        value: level
      };
      emit(
        // eslint-disable-next-line vue/custom-event-name-casing
        "startBattle",
        monsters.monsterIds.map((monsterId: number) => ({ monsterId, level })),
        option
      );
    };
    return {
      Dialog,
      close,
      open,
      towerTab,
      levelList,
      towterActive,
      currentLevel,
      handleStartBattle
    };
  }
};
